import { memo } from 'react';
import { Markup } from 'interweave';
import { addPointsInText, boldBetweenAsterisks } from '../../../../helpers/app';
import InformationLoader from '../../Loader/Information/InformationLoader';
import DetailLoader from '../../Loader/Detail/DetailLoader';
import { images } from '../../../../constants/images';
import styles from '../../publicationDetail.module.scss';
import Button from '../../../Button';
import { PublicationInformationProps } from '../../interfaces';

const PublicationInformation = ({
  publication,
  loading,
  logoDealerships,
  handleDealerLogoClick,
  brand,
  type,
  vehicleTypeSelected,
  children,
  getMinPrice,
  hasValidSuggestedPricesPublication,
  getPriceCategoryPublication,
  selectedVehicleData,
  selectedVersion
}: PublicationInformationProps) => {
  const { images } = require('../../../../constants/images');

  if (loading && !publication?.id) {
    return (
      <div className={`${styles.information} ${loading && styles.loader}`}>
        <InformationLoader />
      </div>
    );
  }

  const renderPriceIndicator = () => {
    if (!hasValidSuggestedPricesPublication || !getPriceCategoryPublication) {
      return null;
    }

    const className = type === 'myPublication'
      ? styles.priceIndicatorMyPublication
      : styles.priceIndicatorPublication;

    return (
      <div className={className} style={{ display: 'flex', alignItems: 'center' }}>
        <img
          src={
            getPriceCategoryPublication() === "good"
              ? images.checkVerde
              : getPriceCategoryPublication() === "fair"
                ? images.checkAmarillo
                : images.checkRojo
          }
          alt="Indicador de precio"
          className={styles.priceIcon}
          style={{ width: '16px', height: '16px', marginRight: '4px' }}
        />
        {getPriceCategoryPublication() === "good"
          ? "Buen precio"
          : getPriceCategoryPublication() === "fair"
            ? "Precio justo"
            : "Precio elevado"}
      </div>
    );
  };


  const renderPrice = () => {
    if (brand) {
      return (
        <>
          <p className={styles.pricesBrand}>Desde ${addPointsInText(getMinPrice)} (*)</p>
          <p className={styles.subTextPricesBrand}>(*) Precios referenciales</p>
        </>
      );
    }
    if (publication?.iva) {
      return (
        <>
          <p className={styles.priceIva}>$ {addPointsInText(publication?.price)}</p>
          {publication?.iva && vehicleTypeSelected === "new" && (
            <p className={styles.subTextPricesIva}>+ IVA</p>
          )}
        </>
      );
    }
    return <p className={styles.price}>$ {addPointsInText(publication?.price)}</p>;

  };

  const renderStatusAndActions = () => {
    if (publication?.sold) {
      return <h3 className={styles.sold}>Vendido</h3>;
    }

    if (type === 'myPublication' || type === 'publication') {
      return (
        <div style={{ width: 'auto' }}>
          {renderPriceIndicator()}
          <div className={styles.childrenPublication}>{children}</div>
        </div>
      );
    }

    if (type === 'salePost') {
      return (
        <div style={{ width: 'auto' }}>
          {renderPriceIndicator()}
        </div>
      );
    }

    return null;
  };
  const renderDetails = () => {
    if (loading) {
      return (
        <ul className={styles.detail}>
          <DetailLoader />
        </ul>
      );
    }

    if (type === "salePost") {
      if (!publication?.records || !Array.isArray(publication.records) || publication.records.length === 0) {
        return null;
      }

      return (
        <ul className={styles.detail}>
          <h3 className={styles.detailSubTitle}>Información provista por el vendedor</h3>
          {publication.records.map((item: any, index: number) => (
            <li key={index}>
              <img src={item?.icon} alt={item?.name} />
              <Markup content={boldBetweenAsterisks(item?.value)} />
            </li>
          ))}
        </ul>
      );
    }

    if (!publication?.detail || !Array.isArray(publication.detail)) {
      return null;
    }

    if (vehicleTypeSelected === "new") {
      return <ul className={styles.detail}></ul>;
    }


    return (
      <ul className={styles.detail}>
        <h3 className={styles.detailSubTitle}>Información provista por el vendedor</h3>
        {publication.detail.map((item: any, index: number) => {
          if (item?.key === "bonus") return null;
          return (
            <li key={index}>
              <img src={item?.icon} alt={item?.value} />
              <Markup content={boldBetweenAsterisks(item?.value)} />
            </li>
          );
        })}
      </ul>
    );
  };

  return (
    <div className={`${styles.information} ${(publication?.certified || publication?.financingBonus) && styles.notPaddingBottom}`}>
      {/* Logo del concesionario */}
      {logoDealerships && (
        <div className={brand ? styles.brandLogo : styles.dealerLogo} onClick={handleDealerLogoClick}>
          <img src={logoDealerships} alt={brand ? "Brand logo" : "Dealer logo"} />
        </div>
      )}

      {/* Descripción básica */}
      <p className={styles.description}>
        {selectedVehicleData?.year || publication?.year} | {addPointsInText(selectedVehicleData?.mileage || publication?.mileage)} km
      </p>

      {/* Título */}
      <h2 className={styles.title}>{publication?.title}</h2>

      {/* Versión */}
      {publication?.version && !brand && (
        <h3 className={styles.version}>{publication.version}</h3>
      )}

      {/* Precio */}
      {renderPrice()}

      {/* Estado y acciones */}
      {renderStatusAndActions()}

      {/* Detalles */}
      {renderDetails()}

      {/* Children (botones de acción) */}
      {type !== "myPublication" && type !== "salePost" ? children : null}
      {type === "salePost" ? <div className={styles.buttonss}>
        <Button
          className={styles.btn}
          title="Negociar"
          onPress={() => console.log('Negociar')}
          tertiary
          disabled
          size='small'
        />
        <Button
          className={styles.btn}
          title="Comprar"
          onPress={() => console.log('Comprar')}
          primary
          disabled
          size='small'
        />
      </div> : null}
    </div>
  );
};

export default memo(PublicationInformation);
